export default __webpack_public_path__ + "static/media/GuilleAlpha.0a0dc9e4.png";